import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 12a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0","key":"svg-0"}],["path",{"d":"M19 12a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0","key":"svg-1"}],["path",{"d":"M11 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}]]

const IconBrandMixpanel = createReactComponent('outline', 'brand-mixpanel', 'BrandMixpanel', __iconNode);

export default IconBrandMixpanel;